<button class="customHeaderLabel" type="button" (click)="emitHeader($event)" [ngClass]="{'disabled': isDisabled}" [disabled]="isDisabled" [attr.aria-label]="displayName" [attr.aria-expanded]="ariaExpanded">
  <span class="drill-down-btn" aria-hidden="true" style="font-size: 18px; font-weight: initial; vertical-align: top; margin-right: 5px;">+</span>
  <span title="{{displayName}}">{{displayName}}</span>
</button>
